import { FC, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ReactComponent as LoadingIcon } from "images/load.svg";
import styles from "./DownloadBackground.module.sass";
import cn from "classnames";

export const DownloadBackground: FC = () => {
	const [delay, setDelay] = useState<boolean>(false);
	useEffect(() => {
		setDelay(true);
	}, []);

	return createPortal(
		<div className={cn(styles.overlay, delay && styles.delay)}>
			<LoadingIcon className="loading-icon" />
		</div>,
		document.body,
	);
};
